export enum AlertId {
  CountryUserWhiteList = 's10_constants_cloud_services_country_user_whitelist',
  RestrictedCountries = 's10_constants_cloud_services_restricted_countries',
  ApprovedCountries = 's10_constants_cloud_services_approved_countries',
}

export const CONFIGURABLE_ALERTS = new Set<string>([
  AlertId.CountryUserWhiteList,
  AlertId.RestrictedCountries,
  AlertId.ApprovedCountries,
]);
